// src/pages/Auth0Return/Auth0Return.js
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useAnalytics } from '../hooks/useAnalytics';

const Auth0Return = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { trackEvent } = useAnalytics();
  
  useEffect(() => {
    // Check for verification error
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');
    
    if (error === 'access_denied' && errorDescription?.includes('verify your email')) {
      // Track verification error
      trackEvent('authentication_error', {
        category: 'Authentication',
        error_type: 'email_verification_required',
        error_description: errorDescription
      });
      
      // Redirect to login with verify message
      navigate('/login?verify=true');
      return;
    }
    
    // Track other errors if they exist
    if (error) {
      trackEvent('authentication_error', {
        category: 'Authentication',
        error_type: error,
        error_description: errorDescription || 'Unknown error'
      });
    }
    
    // If no error, continue with normal flow
    // This will be handled by Auth0 callback
  }, [navigate, searchParams, location.search, trackEvent]);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3
      }}
    >
      <CircularProgress />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Completing authentication...
      </Typography>
    </Box>
  );
};

export default Auth0Return;